<template>
  <div class="flex items-center h-12 text-gray-dark bg-white border border-solid border-black-a20 rounded hover:border-primary-focus cursor-pointer"
       v-on="$listeners"
  >
    <slot />
  </div>
</template>

<script>

export default {
  name: 'FilterBadgeContainer'
}
</script>
